<template>
  <div id="app">
    <Navbar :loggedIn="loggedIn" />

    <div class="mobileContainer">
      <router-view></router-view>
      <Toast position="top-center" />
      <Toast position="top-center" group="generalError">
        <template #message="slotProps">
          <div class="text-center" style="margin: auto">
            <i class="pi pi-exclamation-triangle" style="font-size: 2rem"></i>
            <h6>{{ slotProps.message.summary }}</h6>
            <Button
              class="p-button-danger"
              label="Report bug"
              @click="openBugReport"
            />
          </div>
        </template>
      </Toast>
      <BugReport @close-modal="showBugReportModal=false" v-show="showBugReportModal"></BugReport>
    </div>
  </div>
</template>

<script>
import Navbar from "../src/components/common/Navbar";
import Toast from "primevue/toast";
import LocalStorageService from "../src/services/LocalStorageService";
import { getEmployeeLanguage, setMomentLocale } from "../src/utils";
import BugReport from "@/components/common/BugReport";

export default {
  name: "app",
  components: {
    Navbar,
    Toast,
    BugReport
  },
  data() {
    return {
      loggedIn: null,
      showBugReportModal: false,
    };
  },
  created() {
    const localStorageService = new LocalStorageService();
    const employee = localStorageService.getCurrentEmployee();
    if (employee) {
      const lang = getEmployeeLanguage(employee.language);
      this.$i18n.locale = lang;
      setMomentLocale(lang);
    }
  },
  mounted() {
    this.$root.$on("onLogin", (val) => {
      this.loggedIn = val;
    });
  },
  methods: {
    openBugReport() {
      this.$toast.removeGroup('generalError');
      this.showBugReportModal = true;
    },
  },
};
</script>

<style>
html,
body {
  height: 100%;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.custom-button {
  min-width: 140px;
  padding: 10px;
  font-size: 30px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  z-index: 99;
}
.wr-button {
  width: 50%;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  z-index: 99;
}
.custom-mobile-button {
  width: 100%;
  padding: 10px;
  font-size: 20px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  z-index: 99;
  margin-top: 20px;
}

.custom-button:hover {
  background-color: #f0f0f0;
}
@media (max-width: 700px) {
  .custom-button {
    min-width: initial;
  }
}

@media (max-width: 600px) {
  .title-header h1 {
    font-size: 25px;
    text-align: left;
  }
  p.m-0 {
    text-align: left;
  }
  .title-header.container {
    width: 100%;
    margin-left: 75px;
  }
  .title-header.--margin-right-header {
    margin-right: 75px;
  }
}
.card-body {
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
}

.card-container {
  margin: 18px 15px;
  display: -ms-grid;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(232px, 1fr));
  grid-gap: 18px;
  justify-content: center;
  min-height: 25vh;
}
.btn-container {
  position: absolute;
}

.container-body {
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1 1 auto;
  justify-content: center;
}

.container-main {
  flex: 1 100%;
}
.p-dropdown {
  width: 100%;
  padding: 10px;
}
.mobileContainer {
  margin-bottom: 70px;
  min-height: calc(100% - 150px);
  margin-top: 20px;
  padding: 10px;
  display: flex;
  flex-direction: column;
}
.p-datatable {
  margin-top: 10px;
}
.p-toast {
  margin-top: 71px;
}
.theme-blue .vdatetime-popup__header,
.theme-blue .vdatetime-calendar__month__day--selected > span > span,
.theme-blue .vdatetime-calendar__month__day--selected:hover > span > span {
  background: #007ad9;
}

.theme-blue .vdatetime-year-picker__item,
.theme-blue .vdatetime-time-picker__item {
  color: #d3d3d3;
}

.theme-blue .vdatetime-year-picker__item--selected,
.theme-blue .vdatetime-time-picker__item--selected {
  color: #e4001b;
}
.theme-blue .vdatetime-popup__actions__button {
  color: #007ad9;
}
input[type="color"],
input[type="date"],
input[type="datetime"],
input[type="datetime-local"],
input[type="email"],
input[type="month"],
input[type="number"],
input[type="password"],
input[type="search"],
input[type="tel"],
input[type="text"],
input[type="time"],
input[type="url"],
input[type="week"],
select:focus,
textarea {
  font-size: 16px !important;
}
.vbRed {
  color: #e4001b;
}
.positionRelative {
  position: relative !important;
}
.p-sidebar {
  width: 330px !important;
}

.hasBadge::after {
  content: "";
  position: absolute;
  right: -4px;
  top: -8px;
  display: block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #e4001b;
  border: 2px solid white;
}

.p-component {
  font-family: "Open Sans", "Helvetica Neue", sans-serif !important;
  font-size: 14px !important;
}

.p-sidebar-content {
  height: 100%;
}

.p-dropdown-panel{
  width: 100%;
}
</style>
